import React from 'react';
import { USER_DEFAULT_AVATAR } from 'shared/constants/links';
import { sizeMap, UDImageSize, UDImageStyled } from './styles';

export type { UDImageSize };

interface UDImageProps {
  url?: string | null;
  fallback?: string;
  size?: UDImageSize;
  className?: string;
}

const UDImage = ({ url, fallback = USER_DEFAULT_AVATAR, size = 'md', className }: UDImageProps) => {
  const backgroundUrl = url || fallback;
  const sizePx = sizeMap[size];

  return <UDImageStyled backgroundUrl={backgroundUrl} sizePx={sizePx} className={className} />;
};

export default UDImage;
